<template>
    <transition name='fade'>
        <div
         v-show="show"
        :class="{
            'loading--fullscreen':mode == 'fullscreen',
            'loading--full':mode == 'full',
            'loading--absolute':mode == 'absolute',
            'loading':mode == 'normal',
            'loading--mask':mask
        }"
        :style="wrapStyleObject">
            <span class="loading__box">
                <i class="loading__icon"
                    :style="{
                        'width':size + 'px',
                        'height':size + 'px',
                        'border-color':color,
                        'border-right-color':'transparent'
                    }"></i>
                <em class="loading__title" v-if='title'>{{ title }}</em>
            </span>
        </div>
    </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "normal"
    },
    color: {
      type: String,
      default: "#FF6E40"
    },
    size: {
      type: Number,
      default: 24
    },
    autoSize: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    wrapStyleObject() {
      if (this.autoSize) {
        return {
          width: this.size + "px",
          height: this.size + "px"
        };
      }
    }
  }
};
</script>

<style lang="scss">
@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading {
  position: relative;
  width: 100%;
  height: 45px;
  clear: both;
}
.loading__box {
  position: absolute;
  left: 50%;
  top: 50%;
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  transform: translate3d(-50%, -50%, 0);
}
.loading__title {
  font-size: 12px;
  font-weight: 500;
  padding: 8px 0 0px 0;
  display: block;
  color: #000;
}
.loading__icon {
  display: block;
  width: 24px;
  height: 24px;
  border-top: 2px solid #000;
  border-left: 2px solid #000;
  border-bottom: 2px solid #000;
  border-right: 2px solid transparent;
  border-radius: 50%;
  animation: loading 1s infinite linear;
}
.loading--fullscreen {
  position: relative;
  width: 100%;
  height: 45px;
  clear: both;
  background-color: rgba(0, 0, 0, 0.12);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  transition: ease 0.3s all;
  transform: translate3d(0, 0, 0);
  .loading__box {
    background-color: rgba(255, 255, 255, 0.33);
  }
}
.loading--mask {
  background: rgba(187, 187, 187, 0.37);
}
.loading--full {
  position: relative;
  width: 100%;
  height: 45px;
  clear: both;
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  transition: ease 0.3s all;
  transform: translate3d(0, 0, 0);
}
.loading--absolute {
  position: relative;
  width: 100%;
  height: 45px;
  clear: both;
  position: absolute;
  width: 100%;
  top: 10px;
  z-index: 2;
}
</style>
